import React from 'react';
import { useTranslation } from 'react-i18next';
import { useClient } from '@context/presentation';
import { isAttorneyProfile } from '@utils/profileUtils';
import { ScriptHeader } from '../styles';

export const SectionThree = () => {
    const { t } = useTranslation();
    const { firmShortName } = useClient();
    const profileIsAttorney = isAttorneyProfile(firmShortName);
    
    return (
        <>
            <ScriptHeader>{t('additional_info.script.7')}</ScriptHeader>
            <h4>{t('additional_info.script.8')}</h4>
            <div>{t('additional_info.script.9')}</div>
            <div>
            {
                profileIsAttorney ? 
                    t('additional_info.script.attorney_close') : t('additional_info.script.contingency_close')
            }
            </div>
            <h4>{t('additional_info.script.11')}</h4>
            <div>{t('additional_info.script.12')}</div>
            <div>{t('additional_info.script.13')}</div>
        </>
    );
};
